import { Button, MenuItem, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/iconify';
import ImageQRCodeModal from 'src/components/modal/ImageQRCodeModal';
import { FormatNumber, glb_sv } from 'src/utils';

const DetailDevice = ({ dataDevice, type }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [visibleImageQR, setVisibleImageQR] = useState(false);

    const renderDepartment = (arrDepart) => {
        let str = '';
        if (arrDepart) {
            arrDepart.map((department) => {
                if (department.value !== 1) {
                    str += department.label + ', ';
                }
            });
        }
        return str;
    };

    if (type === 'base') {
        return (
            <>
                <ImageQRCodeModal
                    visible={visibleImageQR}
                    setVisible={setVisibleImageQR}
                    valueImageQR={dataDevice?.device_cd}
                    valueNameDevice={dataDevice?.device_nm}
                    valueCodeDevice={dataDevice?.device_cd}
                />
                <Stack
                    display={'flex'}
                    flexDirection={'row'}
                    flexWrap={'wrap'}
                    gap={2}
                    justifyContent={'space-between'}
                >
                    <Stack
                        display={'flex'}
                        flexDirection={'col'}
                        flexWrap={'wrap'}
                        gap={0}
                        // justifyContent={'space-between'}
                    >
                        <Typography variant="subtitle1" sx={{ color: 'text.primary', fontSize: '18px' }}>
                            {glb_sv.convertMultipleLanguages(dataDevice?.device_nm)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('code_device')}: {dataDevice?.device_cd}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('group_devices')}: {glb_sv.convertMultipleLanguages(dataDevice?.group_nm)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('price')}: {FormatNumber(dataDevice?.price)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('status')}:{dataDevice?.status_action === '0' ? t('borrowing') : t('take')}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('quantity_device_')}: {dataDevice?.total_quantity ? dataDevice?.total_quantity : 0}
                        </Typography>
                    </Stack>
                    <Stack
                        display={'flex'}
                        flexDirection={'col'}
                        flexWrap={'wrap'}
                        // justifyContent={'center'}
                        style={{
                            width: fullScreen ? '18%' : '20%',
                        }}
                    >
                        <img
                            // style={{
                            //     width: fullScreen ? '55%' : '55%',
                            // }}
                            src={
                                dataDevice?.img_device
                                    ? `${glb_sv.urlGetProductImage(dataDevice?.img_device)}`
                                    : `${glb_sv.urlGetProductImage(dataDevice?.pic_device)}`
                            }
                            alt=""
                        />
                        <Button
                            // style={{
                            //     width: fullScreen ? '55%' : '55%',
                            // }}
                            onClick={() => setVisibleImageQR(true)}
                            startIcon={<Iconify icon="clarity:qr-code-line" />}
                        >
                            QR
                        </Button>
                    </Stack>
                </Stack>
            </>
        );
    }
    if (type === 'property') {
        return (
            <Stack spacing={1} sx={{ p: 0 }}>
                <Stack direction="column" sx={{ px: 1, py: 1 }}>
                    {dataDevice?.properties_device?.length > 0 &&
                        dataDevice?.properties_device.map((property, index) => (
                            <MenuItem key={index} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{ color: 'text.secondary', paddingRight: 0.3 }}
                                    noWrap
                                ></Typography>
                                {property.label
                                    ? glb_sv.convertMultipleLanguages(property.label) +
                                      ': ' +
                                      glb_sv.convertMultipleLanguages(property?.value)
                                    : '--/--'}
                            </MenuItem>
                        ))}
                    {dataDevice?.pic_properties_device && (
                        <MenuItem sx={{ display: 'flex', alignItems: 'center' }}>
                            <Typography
                                sx={{
                                    fontSize: '16px',
                                    color: 'text.primary',
                                    width: 'fit-content',
                                }}
                            >
                                <Typography noWrap>{t('img_properties')}</Typography>
                                <img
                                    src={
                                        dataDevice?.pic_properties_device &&
                                        `${glb_sv.urlGetProductImage(dataDevice?.pic_properties_device)}`
                                    }
                                    alt=""
                                />
                            </Typography>
                        </MenuItem>
                    )}
                </Stack>
            </Stack>
        );
    }
    return (
        <>
            <ImageQRCodeModal
                visible={visibleImageQR}
                setVisible={setVisibleImageQR}
                valueImageQR={dataDevice?.device_cd}
                valueNameDevice={dataDevice?.device_nm}
                valueCodeDevice={dataDevice?.device_cd}
            />
            <Stack spacing={1} sx={{ p: 0 }}>
                <Stack direction="column" sx={{ px: 1, py: 1 }}>
                    <Stack display={'flex'} alignItems="center" justifyContent={'center'}>
                        <img
                            style={{
                                maxWidth: '100%',
                                width: '38%',
                                backgroundColor: '#999',
                            }}
                            src={
                                dataDevice?.img_device
                                    ? `${glb_sv.urlGetProductImage(dataDevice?.img_device)}`
                                    : `${glb_sv.urlGetProductImage(dataDevice?.pic_device)}`
                            }
                            alt=""
                        />
                    </Stack>
                    <Stack spacing={0.5} sx={{ pl: 1.5, pt: 3 }}>
                        <Typography variant="subtitle1" sx={{ color: 'text.primary', fontSize: '18px' }}>
                            {glb_sv.convertMultipleLanguages(dataDevice?.device_nm)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('code_device')}: {dataDevice?.device_cd}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('group_devices')}: {dataDevice?.group_nm}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('price')}: {FormatNumber(dataDevice?.price)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('supplier')}: {dataDevice?.supplier_nm}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('producer')}: {dataDevice?.producer?.label}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('department')}: {renderDepartment(dataDevice?.depart_json)}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('day_expected')}:
                            {dataDevice?.status_action === '0'
                                ? dayjs(dataDevice?.expiry_date, 'YYYYMMDD').format(' DD/MM/YYYY')
                                : ' --/--'}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('status')}:{dataDevice?.status_action === '0' ? t('borrowing') : t('take')}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                            {t('quantity_device_')}: {dataDevice?.total_quantity ? dataDevice?.total_quantity : 0}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </>
    );
};

export default DetailDevice;
